"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../index");

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- LINK MENU : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'LinkMenu',
  group: _definitionhelpers.groupNames.menus,
  props: {
    name: {
      type: 'string',
      default: 'linkmenu'
    },
    indicator: {
      type: 'object',
      default: _react.default.createElement("span", null, "Menu Indicator ", _react.default.createElement(_index.Icon, {
        name: "sort-down"
      }))
    },
    hideGroupTitles: {
      type: 'boolean',
      default: true,
      options: [false, true]
    },
    groups: {
      type: 'array',
      default: [{
        name: 'accountitems',
        title: 'Account',
        items: [{
          name: 'profile',
          text: 'Profile Information',
          icon: 'id-card',
          type: 'action',
          action: function action() {
            return console.log('menu item clicked');
          }
        }, {
          name: 'general',
          text: 'Account Settings',
          icon: 'cog',
          type: 'action',
          action: function action() {
            return console.log('menu item clicked');
          },
          disabled: true
        }]
      }, {
        name: 'logoutitems',
        title: null,
        items: [{
          name: 'menu-logout',
          text: 'Log out',
          icon: 'sign-out-alt',
          type: 'action',
          action: function action() {
            return console.log('menu item clicked');
          }
        }]
      }]
    }
  }
};
exports.default = _default;